export const resultsSectionSiteCoreKeys = {
  header: "Projects.SearchProjects.ResultsSection",
  allProjectsSectionHeader:
    "SearchProjects.ResultsSection.AllProjectsSectionHeader",
  projectNameTableColumn:
    "SearchProjects.ResultsSection.ProjectNameTableColumn",
  projectKeyTableColumn: "SearchProjects.ResultsSection.ProjectKeyTableColumn",
  clientNameTableColumn: "SearchProjects.ResultsSection.ClientNameTableColumn",
  projectStatusTableColumn:
    "SearchProjects.ResultsSection.ProjectStatusTableColumn",
  productLineTableColumn:
    "SearchProjects.ResultsSection.ProductLineTableColumn",
  projectFrameworkTableColumn:
    "SearchProjects.ResultsSection.ProjectFrameworkTableColumn",
  numberOfProgramsTableColumn:
    "SearchProjects.ResultsSection.NumberOfProgramsTableColumn",
  projectManagerTableColumn:
    "SearchProjects.ResultsSection.ProjectManagerTableColumn",
  billingOfficeTableColumn:
    "SearchProjects.ResultsSection.BillingOfficeTableColumn",
  salesOfficeTableColumn:
    "SearchProjects.ResultsSection.SalesOfficeTableColumn",
  projectFeeTableColumn: "SearchProjects.ResultsSection.ProjectFeeTableColumn",
  createdDateTableColumn:
    "SearchProjects.ResultsSection.CreatedDateTableColumn",
  actionTableColumn: "SearchProjects.ResultsSection.ActionTableColumn",
  projectStatusList: "SearchProjects.ResultsSection.ProjectStatusList",
  poNumberTableColumn: "SearchProjects.ResultsSection.PONumberTableColumn",
};

export const searchProjectsHeaderSiteCoreKeys = {
  header: "Projects.SearchProjects.SearchProjectsHeader",
  createNewProjectButton:
    "SearchProjects.SearchProjectsHeader.CreateNewProjectButton",
};

export const searchSectionSiteCoreKeys = {
  header: "Projects.SearchProjects.SearchSection",
  contains: "FilterBy.Contains",
  projectName: "SearchProjects.SearchSection.ProjectName",
  projectKey: "SearchProjects.SearchSection.ProjectKey",
  clientName: "SearchProjects.SearchSection.ClientName",
  clientCode: "SearchProjects.SearchSection.ClientCode",
  productLineDropDown: "SearchProjects.SearchSection.ProductLineDropDown",
  projectManagerDropDown: "SearchProjects.SearchSection.ProjectManagerDropDown",
  projectStatusDropDown: "SearchProjects.SearchSection.ProjectStatusDropDown",
  participantName: "SearchProjects.SearchSection.ParticipantName",
  filterByList: "SearchProjects.SearchSection.FilterByList",
  projectStatusList: "SearchProjects.SearchSection.ProjectStatusList",
};
